import styled, { keyframes } from "styled-components";

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;

  & > div {
    margin-bottom: 0;
    margin-left: 8px;
  }
`;

export const GroupLabel = styled.label`
  margin-bottom: 0;
  padding-left: 0px;
  font-weight: bold;
  font-size: 1rem;
  color: ${(p) => (p.error ? p.theme.colors[p.error] : p.theme.colors.primary)};
`;

const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(
        result[3],
        16
      )}`
    : null;
};

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  overflow: hidden;
  cursor: ${(p) => (p.disabled ? "default" : "pointer")};
  padding: 20px;
  &:hover {
    background-color: ${(p) =>
      p.disabled
        ? "inherit"
        : hexToRgb(p.theme.colors.primary)
        ? `rgba(${hexToRgb(p.theme.colors.primary)}, 0.1)`
        : "rgba(0, 0, 0, 0.1)"};
  }
`;

export const Box = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background-color: ${(p) =>
    p.disabled && p.checked
      ? "#888"
      : p.checked
      ? p.theme.colors.primary
      : "#fff"};
  border: 2px solid
    ${(p) =>
      p.disabled
        ? "#888"
        : p.error
        ? p.theme.colors[p.error]
        : p.theme.colors.primary};
  border-radius: 3px;
  z-index: 1;
`;

export const Check = styled.em`
  color: #fff;
`;

const clickEffect = keyframes`
  0% {
    width: 20px;
    height: 20px;
    opacity: 0;
    box-shadow: 0 0 5px inset rgba(0, 0, 0, 0);
  }
  40% {
    width: 100%;
    height: 100%;
    opacity: 0.2;
    box-shadow: 0 0 15px inset rgba(0, 0, 0, 0.2);
  }
  100% {
    width: 100%;
    height: 100%;
    opacity: 0;
    box-shadow: 0 0 15px inset rgba(0, 0, 0, 0);
  }
`;

export const Shadow = styled.div`
  width: ${(p) => (!p.focus ? "10px" : "100%")};
  height: ${(p) => (!p.focus ? "10px" : "100%")};
  background-color: ${(p) => p.theme.colors.primary};
  border-radius: 50%;
  opacity: ${(p) => (!p.focus ? 0 : 0.2)};

  @media (prefers-reduced-motion: no-preference) {
    &.animate {
      animation: ${clickEffect} 0.4s linear;
    }
  }
`;

export const Input = styled.input`
  position: absolute;
  z-index: -1;
  opacity: 0;
  &:focus {
    outline: none;
  }
`;

export const Label = styled.label`
  padding-left: 5px;
  margin-bottom: 0;
  color: ${(p) =>
    p.disabled ? "#888" : p.error ? p.theme.colors[p.error] : "inherit"};
  cursor: ${(p) => (p.disabled ? "default" : "pointer")};
`;

export const HorizontalCheckboxGroupWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const HorizontalCheckboxButton = styled.button`
  display: inline-flex;
  align-items: center;
  min-height: 40px;
  padding: 8px 12px;
  border: 1px solid
    ${(p) =>
      p.selected
        ? p.theme.colors.primary
        : p.error
        ? p.theme.colors[p.error]
        : "#8f8f8f"};
  border-radius: 3px;
  background-color: #fff;
  color: ${(p) => (p.disabled ? "#888" : "inherit")};
  opacity: ${(p) => (p.disabled ? 0.7 : 1)};
  cursor: ${(p) => (p.disabled ? "default" : "pointer")};
  transition: background-color 0.15s ease, border-color 0.15s ease,
    box-shadow 0.15s ease;

  &:hover {
    background-color: ${(p) =>
      p.disabled ? "#f3f3f3" : p.selected ? "#e8f1ff" : "#efefef"};
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    box-shadow: 0 0 0 3px
      ${(p) =>
        hexToRgb(p.theme.colors.primary)
          ? `rgba(${hexToRgb(p.theme.colors.primary)}, 0.25)`
          : "rgba(0, 0, 0, 0.2)"};
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const HorizontalCheckboxCheck = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  margin-right: 8px;
  border: 1px solid
    ${(p) =>
      p.disabled
        ? "#999"
        : p.selected
        ? p.theme.colors.primary
        : p.error
        ? p.theme.colors[p.error]
        : "#777"};
  border-radius: 3px;
  background-color: ${(p) =>
    p.disabled && p.selected
      ? "#999"
      : p.selected
      ? p.theme.colors.primary
      : "#fff"};
  color: #fff;
  flex-shrink: 0;
`;

export const HorizontalCheckboxLabel = styled.span`
  line-height: 1.2;
  hyphens: auto;
`;
